import { render, staticRenderFns } from "./ManChildBody.vue?vue&type=template&id=58bf6a7d&scoped=true&"
import script from "./ManChildBody.vue?vue&type=script&lang=js&"
export * from "./ManChildBody.vue?vue&type=script&lang=js&"
import style0 from "./ManChildBody.vue?vue&type=style&index=0&id=58bf6a7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bf6a7d",
  null
  
)

export default component.exports